import React, { forwardRef } from "react"

interface IFlexProps extends React.HTMLAttributes<HTMLDivElement> {
    // Set the Flex container to align inline with other inline Flex containers
    inline?: boolean
    // Additional styles
    style?: React.HTMLAttributes<HTMLDivElement>["style"]
    // This is a shorthand for 'flex-direction' and 'flex-wrap' properties,
    // which together define the Flex container main and cross-axes
    flow?: React.CSSProperties["flexFlow"]
    // Modifies the behavior of the flex-wrap property.
    wrap?: React.CSSProperties["flexWrap"]
    // Align the items in the Flex container along the main-axis (horizontally)
    justifyContent?: React.CSSProperties["justifyContent"]
    // Align the items in the Flex container along the cross-axis (vertically)
    alignItems?: React.CSSProperties["alignItems"]
    // It is similar to align-items, but instead of aligning flex items, it aligns flex line
    alignContent?: React.CSSProperties["alignContent"]
    // Gap between Flex items
    gap?: React.CSSProperties["gap"]
}

const Flex = forwardRef<HTMLDivElement, React.PropsWithChildren<IFlexProps>>(({
    inline,
    flow,
    wrap,
    justifyContent,
    alignItems,
    alignContent,
    gap,
    style,
    children,
    ...others
}, ref) => {
    return (
        <div style={{
            display: inline ? "inline-flex" : "flex",
            flexFlow: flow,
            flexWrap: wrap,
            justifyContent,
            alignItems,
            alignContent,
            gap,
            ...style
        }}
            {...others}
            ref={ref}
        >
            {children}
        </div>
    )
})

Flex.displayName = "Flex"
export default Flex
